import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Icon from "@mui/material/Icon";
import Input from '@mui/material/Input';
import Chip from '@mui/material/Chip';
import { Stack } from "@mui/material";
import { makeStyles, useTheme } from '@mui/material/styles';
import { ToastContainer, toast } from 'react-toastify';
import anmolLogo from "../../assets/images/anmol_logo_transparent.png";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import SoftSelect from "components/SoftSelect";
import { ThreeDots } from 'react-loader-spinner';
import { useDropzone } from "react-dropzone";
import "layouts/style.css";
import { Bars } from 'react-loader-spinner'
import Select from "react-select";
import { DOCUMENT_URL } from "assets/globalAPI/apiGlobal";
import { saveVendorFormUploads } from "assets/globalAPI/apiGlobal";
import { updateVendorFormUploads } from "assets/globalAPI/apiGlobal";
import SimpleBackdrop from "layouts/SimpleBackdrop";
import { fetchAllVendors } from "assets/globalAPI/apiGlobal";
import { updateVendorFormUploadsRework } from "assets/globalAPI/apiGlobal";


import { getReworkReference, getReworkVendor, populateReworkFields, getDocumentUrl, prepareReworkUploads } from "layouts/VendorRework/reworkUtils";

const VendorRework2=()=>{
     const navigate= useNavigate();
     const location = useLocation();
     const refID = getReworkReference(location.search, localStorage.getItem("reference_id"));
        const [loaderspinner, setLoaderSpinner] = useState(false);
        const [isMsme, setIsMsme] = useState(false);
        const [isfssi, setIsFssi] = useState(false);
        const toastId = React.useRef(null);
        const [loader, setLoader] = useState(false);
        const [isActive, setIsActive] = useState(false);
        const [formSubmitted, setIsFormSubmiteed] = useState(false);
        const [declaration, setDeclartion]= useState(false)
        const [enabledFields,setEnabledFields]= useState([]);
        const [isDone,setIsDone]= useState(true)
        const [loadError, setLoadError] = useState("");
        // const [gstnDoc, setGstnDoc]= useState(null);
        // const [panDoc, panDoc]= useState(null);
        // const [tdsDoc, tdsDoc]= useState(null);
        // const [latestCoDoc, setGstnDoc]= useState(null);
        // const [gstnDoc, setGstnDoc]= useState(null);
        // const [gstnDoc, setGstnDoc]= useState(null);

        const [formValues, setFormValues] = useState({
            reference_id: { value: refID, error: false },
              gstn_document: { value: null,error: false }, 
              pan_document: { value: null,error: false },
              latest_co_status_document: { value: null,error: false },
              tds_document: { value: null,error: false },
              msme_document: {value: null, error: false},
              fssai_document: {value: null, error: false},
              cancel_cheque_document: {value: null, error: false},
              agreement_copy: {value: null, error: false},
              declaration: {value: 'I Agree', error: false}
            });

            const [formValues2, setFormValues2] = useState({
                reference_id: { value: refID, error: false },
                gstn_document: { value: null,error: false }, 
                pan_document: { value: null,error: false },
                latest_co_status_document: { value: null,error: false },
                tds_document: { value: null,error: false },
                msme_document: {value: null, error: false},
                fssai_document: {value: null, error: false},
                cancel_cheque_document: {value: null, error: false},
                agreement_copy: {value: null, error: false},
              });


            useEffect(() => {
              let cancelled = false;
              setIsDone(true);
              setLoadError("");
              const loadVendor = async () => {
                setIsActive(true);
                try {
                  if (!refID) throw new Error("No vendor reference was supplied. Open rework from the vendor list or your rework link.");
                  const response = await fetchAllVendors({ page: 1, reference_id: refID });
                  const vendor = getReworkVendor(response.data, refID);
                  if (cancelled) return;
                  setFormValues2(previous => populateReworkFields(previous, vendor));
                  setFormValues(previous => Object.fromEntries(Object.entries(previous).map(([key, field]) => [
                    key, { ...field, value: key === "reference_id" ? refID : key === "declaration" ? "I Agree" : null, error: false }
                  ])));
                  setDeclartion(false);
                  localStorage.setItem("reference_id", refID);
                  setIsDone(false);
                } catch (error) {
                  if (!cancelled) setLoadError(error.response?.data?.message || error.message);
                } finally {
                  if (!cancelled) setIsActive(false);
                }
              };
              loadVendor();
              return () => { cancelled = true; };
            }, [refID]);
                const isFieldEnabled = (fieldName) => enabledFields.includes(fieldName);

                const handleFormChange = (field, value) => {
                  let updatedValue = value;
                  console.log("here is a file>> ", value)
              
                  // Handle file inputs properly
                  if (field.endsWith("_document") && value instanceof File) {
                      updatedValue = value; // Store the file object directly
                  }
              
                  // Handle multi-select fields
                  if (field === "nature_of_business" || field === "business_category") {
                      updatedValue = value.map(option => option.value);
                  }
              
                  // Update state
                  setFormValues((prevState) => ({
                      ...prevState,
                      [field]: {
                          ...prevState[field], // Preserve existing properties (like `error`)
                          value: updatedValue, // Store the updated value
                      },
                    //   reference_id: {
                    //       ...prevState.reference_id,
                    //       value: localStorage.getItem("reference_id") || refID ||"", // Ensure refID is always set
                    //   }
                  }));
              };


                const handlePreviousPage=()=>{
                    navigate("/vendor/rework?refid=" + encodeURIComponent(refID));
                    
                }

                const handleSubmitForm=async(e)=>{
                  e.preventDefault();
                  if (isDone || isActive || !refID || !declaration) return;
                  setIsActive(true)

                  console.log("here is form>> ",formValues)

                   let finalFormValues;
                   try {
                     finalFormValues = await prepareReworkUploads(formValues, formValues2, DOCUMENT_URL);
                   } catch (error) {
                     toast.error(error.message);
                     setIsActive(false);
                     return;
                   }
                      const allEmpty = Object.keys(finalFormValues).every((key) => {
    if (key === "declaration" || key === "reference_id") return true;
    return !finalFormValues[key].value; // null, undefined, or ""
  });
   if (allEmpty) {
      if(!toast.isActive(toastId.current)){
                                      toastId.current= toast.error("Please upload Files",{
                                                className: "small-toast"
                                              })
                                    }
                                    setIsActive(false)
      return;
    }

    //               const requiredFields = [
    //                 "pan_document"
    //               ];

    //               let hasError = false;
    // let updatedValues = { ...formValues };

    // for (let key in formValues2) {
    //   if (
    //     key !== "reference_id" &&
    //     key !== "declaration" &&
    //     key !== "pan_document" &&
    //     formValues2[key].value !== null &&
    //     formValues2[key].value !== "" &&
    //     (updatedValues[key].value == null || updatedValues[key].value == "")
    //   ) {
    //     requiredFields.push(key);
    //   }
    // }
  
    // requiredFields.forEach(key => {
    //   if (!updatedValues[key]?.value) {
    //     updatedValues[key] = { ...updatedValues[key], error: true };
    //     hasError = true;
    //   } else {
    //     updatedValues[key] = { ...updatedValues[key], error: false };
    //   }
    // });
    

    // setFormValues(updatedValues); 
    // console.log("here are the updated values and required fields>>> ", updatedValues, requiredFields)

    // if (hasError) {
    //   console.log("cannot submit, fill mandatory")
     
    //   if (!toast.isActive(toastId.current)) {
    //     toastId.current = toast.error("Please Fill All The Required Fields", {
    //       className: "small-toast"
    //     });
    //   }

    //   setIsActive(false)
      
    //   return;
    // }
                  console.log("final formValues>> ", formValues)
                  const formData= new FormData();

                //    const allowedTypes = ["application/pdf", "image/jpeg", "image/png", "image/jpg"];
                  
                //   for (let key in formValues) {
                //     if(key=="declaration"|| key=="reference_id"){
                //       continue; // Skip declaration and reference_id
                //     }
                //     const file = formValues[key].value;
                //     if (file) {
                //       if (!allowedTypes.includes(file.type)) {
                //         if (!toast.isActive(toastId.current)) {
                //           toastId.current = toast.error(`File types must be PDF or Image (JPG/PNG).`, {
                //             className: "small-toast"
                //           });
                //         }
                //         // alert(`File type for ${key} must be PDF or Image (JPG/PNG).`);
                //         setIsActive(false);
                //         return;
                //       }
                //     }
                //   }

                //   Object.keys(formValues).forEach(key => {
                //     if (formValues[key].value) {
                //         console.log("formValues[key].value-->",formValues[key].value);
                //         formData.append(key, formValues[key].value);
                //     }
                // });

                  Object.keys(finalFormValues).forEach(key => {
                    if (key !== "reference_id" && finalFormValues[key].value) {
                        formData.append(key, finalFormValues[key].value); // Append file
                    }
                  });
                //   let localUser= JSON.parse(localStorage.getItem("userdetails"))
                //   formData.append('userId',localUser.id)
                  formData.append('reference_id',refID)
                
                // formData.append("reference_id", (refID).toString()); 

                  // Object.entries(formValues).forEach(([key, obj]) => {
                  //   if (Array.isArray(obj.value)) {
                  //     obj.value.forEach((val, index) => {
                  //       formData.append(`${key}[${index}]`, val);
                  //     });
                  //   } else {
                  //     formData.append(key, obj.value);
                  //   }
                  // });

                  formData.forEach((value, key) => {
                    console.log(`${key}: ${value}`);
                  });

                  

                  try{
                    const response= await updateVendorFormUploadsRework(formData);
                    const res= response.data;
                    console.log("Here is upload response>> ", res);
                    if(res.status){
                      if(!toast.isActive(toastId.current)){
                        toastId.current= toast.success("Updation Submitted Successfully",{
                                  className: "small-toast"
                                })
                      }
                      // setIsActive(false)
                      setIsFormSubmiteed(true);
                    formData.forEach((value, key) => {
                      console.log(`${key}: ${value}`);
                    });
                    setTimeout(()=>{

                      navigate("/vendor/rework/confirm")
                  }, 2000)
                  localStorage.removeItem("filledForm2");
                    } else{
                      if(!toast.isActive(toastId.current)){
                        toastId.current= toast.warning("Could Not Update vendor",{
                                  className: "small-toast"
                                })
                      }
                      setIsActive(false)
                      console.log("why not updated>> ", res)
                    }
                  }catch(err){
                    console.log("Error uploading files>> ", err)
                    if(!toast.isActive(toastId.current)){
                      toastId.current= toast.error("Registration Error",{
                                className: "small-toast"
                              })
                    }
                    setIsActive(false)
                  }
                   
                    
                            localStorage.removeItem("filledForm2");
                            // localStorage.setItem("filledForm", JSON.stringify(formValues))

                    
                  }
  
                return(
                    <>
                    <ToastContainer/>
                    <SimpleBackdrop openLoader={isActive}/>
                    {loadError && <div role="alert" style={{ padding: "16px", color: "#b71c1c" }}>{loadError}</div>}
                    <Grid>
                    <SoftBox py={0} className="customerblock">
       <Grid container spacing={3}>
       <Grid item xs={12} lg={12} className="headerForm">
       
       <SoftBox p={0} display="flex" alignItems="center" justifyContent="space-between">
<img src={anmolLogo} alt="Logo" style={{ height: 100 }} />

<SoftTypography  variant="h3" id="form_heading" style={{ flex: 1, textAlign: "center" }}>
 Vendor Edit
</SoftTypography>

{/* This empty box ensures the text remains centered */}
<div style={{ width: 50 }}></div>
</SoftBox>


       <Grid>
                     {loaderspinner ? <div style={{
                       position: 'fixed', width: "100%", height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.3)',
                       zIndex: 200000, display: 'flex', justifyContent: 'center', alignItems: 'center', top: '0px', left: '0px',
                     }}>
                       <ThreeDots color="#fff" height={50} width={50} timeout={1000} visible={loaderspinner} />

                     </div> : ""}
       </Grid>
       
       </Grid>
       </Grid>
       </SoftBox>

        <SoftBox className="bp formBG">
            <form noValidate onSubmit={handleSubmitForm}>
            <SoftBox py={3} className="customerblock">
           <Grid container spacing={3}>
             <Grid item xs={12} lg={12}>
               <Card sx={{ overflow: "visible" }}>
                 <SoftBox p={3}>
                   <SoftTypography variant="h5" id="form_heading textUppercase">Upload Documents</SoftTypography>
<SoftTypography variant="caption" color="error" sx={{ display: 'block', mt: 1 }}>
  * Only PDF or images (JPG, JPEG, PNG) are allowed with max size upto 5MB.<br/><br/>
  * Files that were previously uploaded are mandatory to upload again.
</SoftTypography>
                   

                   <SoftBox mt={1}>
                     <Grid container spacing={3}>
                     <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                               CIN (If MCA/ROC is Active){formValues2?.latest_co_status_document && <span > *</span>}
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput  
                             type="file"
                             
                            //  value={formValues.latest_co_status.value}
                            error={formValues.latest_co_status_document.error}
                             onChange={(e) => {
                                                           
                                                           const file = e.target.files[0];
                                                           if (file) {
                                                             const allowedTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];
                                                             if (!allowedTypes.includes(file.type)) {
                                                               if(!toast.isActive(toastId.current)){
                                                                 toastId.current= toast.warning("Only PDF or images (JPG, JPEG, PNG) are allowed",{
                                                                           className: "small-toast"
                                                                         })
                                                               }
                                                               handleFormChange("latest_co_status_document", file);
                                                               return;
                                                             }
                                                             console.log("latest_co file is>>> ", file);
                                                             handleFormChange("latest_co_status_document", file);
                                                           }}}
                             placeholder="Street"
                             id="street"
                             size="medium" 
                             
                             />
                             <a href={getDocumentUrl(formValues2.latest_co_status_document.value, DOCUMENT_URL)} target="_blank" download style={{fontWeight: 'bold', fontSize: "12px", display: formValues2.latest_co_status_document.value===null || formValues2.latest_co_status_document.value==='' && 'none'}} rel="noopener noreferrer">View File</a>
                         </SoftBox>
                       </Grid>
                     <Grid item xs={12} sm={4}>
                                              <SoftBox mb={3}>
                                                <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                  <SoftTypography
                                                    component="label"
                                                    variant="caption"
                                                    fontWeight="bold"
                                                    textTransform="capitalize"
                                                  >
                                                    TDS Exemption/Lower Deduction Certificate*
                                                  </SoftTypography>
                                                </SoftBox>
                                                <SoftInput
                                                  type="file"
                                                  id="tds_doc"
                                                
                                                  // disabled={formValues.tds_exemption?.value !== "Yes"}
                                                  error={formValues.tds_document.error}
                                                  // value={formValues.tds_doc.value}
                                                   onChange={(e) => {
                                                                                                      const file = e.target.files[0];
                                                                                if (file) {
                                                                                  const allowedTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];
                                                                                  if (!allowedTypes.includes(file.type)) {
                                                                                    if(!toast.isActive(toastId.current)){
                                                                                      toastId.current= toast.warning("Only PDF or images (JPG, JPEG, PNG) are allowed",{
                                                                                                className: "small-toast"
                                                                                              })
                                                                                    }
                                                                                    handleFormChange("tds_document", file);
                                                                                    return;
                                                                                  }
                                                                                  console.log("tds_document file is>>> ", file);
                                                                                  handleFormChange("tds_document", file);
                                                                                                      }}}
                                                />
                                                <a href={getDocumentUrl(formValues2.tds_document.value, DOCUMENT_URL)} target="_blank" download style={{fontWeight: 'bold', fontSize: "12px", display: formValues2.tds_document.value===null || formValues2.tds_document.value==='' && 'none'}} rel="noopener noreferrer">View File</a>
                                              </SoftBox>
                                            </Grid>
                        <Grid item xs={12} sm={4}>
                                              <SoftBox mb={3} id="mkcustomer">
                                                  <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                    <SoftTypography
                                                      component="label"
                                                      variant="caption"
                                                      fontWeight="bold"
                                                      textTransform="capitalize"
                                                    >
                                                      GSTN Document{formValues2?.gstn_document && <span > *</span>}
                                                    </SoftTypography>
                                                  </SoftBox>
                                                  <SoftInput
                                                    type="file"
                                                    size="medium"
                                                    name="gstn_document"
                                                    id="gstn_document"
                                                    error={formValues.gstn_document.error}
                                                    
                                                    // value={formValues.gstn_document.value}
                                                     onChange={(e) =>{
                                                                                                          const file = e.target.files[0];
                                                                                                          if (file) {
                                                                                                            const allowedTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];
                                                                                                            if (!allowedTypes.includes(file.type)) {
                                                                                                              if(!toast.isActive(toastId.current)){
                                                                                                                toastId.current= toast.warning("Only PDF or images (JPG, JPEG, PNG) are allowed",{
                                                                                                                          className: "small-toast"
                                                                                                                        })
                                                                                                              }
                                                                                                              handleFormChange("gstn_document", file);
                                                                                                              return;
                                                                                                            }
                                                                                                            console.log("gstn file is>>> ", file);
                                                                                                            handleFormChange("gstn_document", file);
                                                                                                          }}}
                                                  />
                                                   <a href={getDocumentUrl(formValues2.gstn_document.value, DOCUMENT_URL)} target="_blank" download style={{fontWeight: 'bold', fontSize: "12px", display: formValues2.gstn_document.value===null || formValues2.gstn_document.value==='' && 'none'}} rel="noopener noreferrer">View File</a>
                                              </SoftBox>
                                              </Grid>
                                              <Grid item xs={12} sm={4}>
                                              <SoftBox mb={3}>
                                                  <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                    <SoftTypography
                                                      component="label"
                                                      variant="caption"
                                                      fontWeight="bold"
                                                      textTransform="capitalize"
                                                    >
                                                      PAN Document*
                                                    </SoftTypography>
                                                  </SoftBox>
                                                  <SoftInput
                                                    type="file"
                                                    name="pan"
                                                    id="pan"
                                                    
                                                    error={formValues.pan_document.error}
                                                    // value={formValues.pan_document.value}
                                                   onChange={(e) =>{
                                                                                                         const file = e.target.files[0];
                                                                                                         if (file) {
                                                                                                           const allowedTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];
                                                                                                           if (!allowedTypes.includes(file.type)) {
                                                                                                             if(!toast.isActive(toastId.current)){
                                                                                                               toastId.current= toast.warning("Only PDF or images (JPG, JPEG, PNG) are allowed",{
                                                                                                                         className: "small-toast"
                                                                                                                       })
                                                                                                             }
                                                                                                             handleFormChange("pan_document", file);
                                                                                                             return;
                                                                                                           }
                                                                                                           console.log("pan file is>>> ", file);
                                                                                                           handleFormChange("pan_document", file);
                                                                                                         }
                                                                                                       } }
                                                    
                                                    size="medium"
                                                    // inputProps={{ maxLength: "15" }}
                                                  />
                                                  <a href={getDocumentUrl(formValues2.pan_document.value, DOCUMENT_URL)} target="_blank" download style={{fontWeight: 'bold', fontSize: "12px", display: formValues2.pan_document.value===null || formValues2.pan_document.value==='' && 'none'}} rel="noopener noreferrer">View File</a>
                                                </SoftBox>
                                              </Grid>

                                              <Grid item xs={12} sm={4}>
                                              <SoftBox mb={3}>
                                                  <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                    <SoftTypography
                                                      component="label"
                                                      variant="caption"
                                                      fontWeight="bold"
                                                      textTransform="capitalize"
                                                    >
                                                      Latest MSME Document{formValues2?.msme_document && <span > *</span>}
                                                    </SoftTypography>
                                                  </SoftBox>
                                                  <SoftInput
                                                    type="file"
                                                    name="pan"
                                                    id="pan"
                                                  
                                                    error={formValues.msme_document.error}
                                                    // value={formValues.pan_document.value}
                                                     onChange={(e) =>{
                                                                                                          const file = e.target.files[0];
                                                                                                          if (file) {
                                                                                                            const allowedTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];
                                                                                                            if (!allowedTypes.includes(file.type)) {
                                                                                                              if(!toast.isActive(toastId.current)){
                                                                                                                toastId.current= toast.warning("Only PDF or images (JPG, JPEG, PNG) are allowed",{
                                                                                                                          className: "small-toast"
                                                                                                                        })
                                                                                                              }
                                                                                                              handleFormChange("msme_document", file);
                                                                                                              return;
                                                                                                            }
                                                                                                            console.log("msme file is>>> ", file);
                                                                                                            handleFormChange("msme_document", file);
                                                                                                          }
                                                                                                        } }
                                                    
                                                    size="medium"
                                                    // inputProps={{ maxLength: "15" }}
                                                  />
                                                  <a href={getDocumentUrl(formValues2.msme_document.value, DOCUMENT_URL)} target="_blank" download style={{fontWeight: 'bold', fontSize: "12px", display: formValues2.msme_document.value===null || formValues2.msme_document.value==='' && 'none'}} rel="noopener noreferrer">View File</a>
                                                </SoftBox>
                                              </Grid>

                                              <Grid item xs={12} sm={4}>
                                              <SoftBox mb={3}>
                                                  <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                    <SoftTypography
                                                      component="label"
                                                      variant="caption"
                                                      fontWeight="bold"
                                                      textTransform="capitalize"
                                                    >
                                                      FSSAI Document{formValues2?.fssai_document && <span > *</span>}
                                                    </SoftTypography>
                                                  </SoftBox>
                                                  <SoftInput
                                                    type="file"
                                                    name="pan"
                                                    id="pan"
                                                    
                                                    error={formValues.fssai_document.error}
                                                    // value={formValues.pan_document.value}
                                                   onChange={(e) =>{
                                                                                                         const file = e.target.files[0];
                                                                                                         if (file) {
                                                                                                           const allowedTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];
                                                                                                           if (!allowedTypes.includes(file.type)) {
                                                                                                             if(!toast.isActive(toastId.current)){
                                                                                                               toastId.current= toast.warning("Only PDF or images (JPG, JPEG, PNG) are allowed",{
                                                                                                                         className: "small-toast"
                                                                                                                       })
                                                                                                             }
                                                                                                             handleFormChange("fssai_document", file);
                                                                                                             return;
                                                                                                           }
                                                                                                           console.log("fssai file is>>> ", file);
                                                                                                           handleFormChange("fssai_document", file);
                                                                                                         }
                                                                                                       } }
                                                    
                                                    size="medium"
                                                    // inputProps={{ maxLength: "15" }}
                                                  />
                                                  <a href={getDocumentUrl(formValues2.fssai_document.value, DOCUMENT_URL)} target="_blank" download style={{fontWeight: 'bold', fontSize: "12px", display: formValues2.fssai_document.value===null || formValues2.fssai_document.value==='' && 'none'}} rel="noopener noreferrer">View File</a>
                                                </SoftBox>
                                              </Grid>

                                              <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                               Cancel Cheque Document{formValues2?.cancel_cheque_document && <span > *</span>}
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput  
                             type="file"
                             
                            //  value={formValues.latest_co_status.value}
                            error={formValues.cancel_cheque_document.error}
                             onChange={(e) => {
                                                           
                                                           const file = e.target.files[0];
                                                           if (file) {
                                                             const allowedTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];
                                                             if (!allowedTypes.includes(file.type)) {
                                                               if(!toast.isActive(toastId.current)){
                                                                 toastId.current= toast.warning("Only PDF or images (JPG, JPEG, PNG) are allowed",{
                                                                           className: "small-toast"
                                                                         })
                                                               }
                                                               handleFormChange("cancel_cheque_document", file);
                                                               return;
                                                             }
                                                             console.log("latest_co file is>>> ", file);
                                                             handleFormChange("cancel_cheque_document", file);
                                                           }}}
                             placeholder="Street"
                             id="street"
                             size="medium" 
                             
                             />
                             <a href={getDocumentUrl(formValues2.cancel_cheque_document.value, DOCUMENT_URL)} target="_blank" download style={{fontWeight: 'bold', fontSize: "12px", display: formValues2.cancel_cheque_document.value===null || formValues2.cancel_cheque_document.value==='' && 'none'}} rel="noopener noreferrer">View File</a>
                         </SoftBox>
                       </Grid>

                     <Grid item xs={12} sm={4}>
                       <SoftBox mb={3}>
                         <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                           <SoftTypography
                             component="label"
                             htmlFor="agreement_copy"
                             variant="caption"
                             fontWeight="bold"
                           >
                             Agreement Copy
                           </SoftTypography>
                         </SoftBox>
                         <SoftInput
                           type="file"
                           name="agreement_copy"
                           id="agreement_copy"
                           inputProps={{ accept: ".pdf,.jpg,.jpeg,.png" }}
                           error={formValues.agreement_copy.error}
                           onChange={(e) => {
                             const file = e.target.files[0] || null;
                             if (file && !["application/pdf", "image/png", "image/jpeg", "image/jpg"].includes(file.type)) {
                               if (!toast.isActive(toastId.current)) {
                                 toastId.current = toast.warning("Only PDF or images (JPG, JPEG, PNG) are allowed", {
                                   className: "small-toast"
                                 });
                               }
                               e.target.value = "";
                               handleFormChange("agreement_copy", null);
                               return;
                             }
                             handleFormChange("agreement_copy", file);
                           }}
                           size="medium"
                         />
                         {formValues2.agreement_copy?.value && (
                           <a
                             href={getDocumentUrl(formValues2.agreement_copy.value, DOCUMENT_URL)}
                             target="_blank"
                             download
                             style={{ fontWeight: "bold", fontSize: "12px" }}
                             rel="noopener noreferrer"
                           >
                             View File
                           </a>
                         )}
                       </SoftBox>
                     </Grid>

                     </Grid>
                   </SoftBox>
                     <SoftBox py={3} className="customerblock">

                     <Grid container spacing={3}>
                     <Card sx={{ overflow: "visible" }}>
                        <SoftBox p={3}>
                            <div style={{ display: "flex", gap: "8px", alignItems: "baseline" }}>
<input 
// style={{marginTop:'10px'}}
 type="checkbox" 
 style={{ cursor: "pointer", marginTop:'10px' }} 
 checked={declaration} 
 onChange={(e) => setDeclartion(e.target.checked)} 
/>
<SoftTypography variant="h5" id="form_heading">
 <span style={{ fontSize: "12px" }}>
   I/W<span style={{textTransform: 'lowercase'}}>e</span> <span style={{textTransform: 'lowercase'}}> declare that the above information given here in including the attachments are correct to the best of my knowledge. </span>
 </span>
</SoftTypography>
</div>
<Grid container display="flex" justifyContent="space-between" mt={2} >
    {!isDone && 
    <>
<Grid item>
           <SoftButton onClick={handlePreviousPage} variant="contained" color="success">
             Previous
           </SoftButton>
         </Grid>
         <Grid item>
           <SoftButton disabled={isActive || !declaration} type="submit" variant="contained" color="primary">
             Save & Submit
           </SoftButton>
         </Grid>
    </>
    }
       </Grid>
                        </SoftBox>
                     </Card>
                     </Grid>
                     </SoftBox>


                 
                   

                   

                 </SoftBox>
               </Card>
             </Grid>
           </Grid>
         </SoftBox>
            </form>
        </SoftBox>
                    </Grid>
                    </>
                )
}

export default VendorRework2;